import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { EqualHeight, EqualHeightElement } from 'react-equal-height';
import { Animated } from 'react-animated-css';
import { Link } from 'react-router-dom';
import { routes } from '../../routes';

import { images } from '../../assets/images';
import PageTitle from '../../Components/PageTitle';

function Packages() {
	return (
		<>
			<PageTitle title="Packages" />
			<div className="page_content_section">
				<div className="packages_section bg-light pt-5 pb-5">
					<Container>
						<Row>
							<Col>
								<div className="cms_section text-center pb-4">
									<p>
										Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam non omnis architecto nisi velit rerum maiores quia ab labore ratione aspernatur veritatis dolorum, suscipit porro dignissimos? Aliquid, velit quis blanditiis voluptatibus asperiores nulla soluta accusamus quam quaerat a perferendis explicabo porro non reprehenderit et corrupti, ullam odit vero ut molestias adipisicing elit. Magnam non omnis architecto nisi velit rerum maiores quia ab labore ratione! adipisicing elit. Magnam non omnis architecto nisi velit rerum maiores quia ab labore ratione aspernatur veritatis dolorum, suscipit porro dignissimos? Aliquid, velit quis blanditiis voluptatibus asperiores nulla soluta accusamus
									</p>
								</div>
								<div className="packages_listing">
									<EqualHeight>
										<Row className="justify-content-center">
											<Col xl={3} lg={3} md={4} sm={6} xs={12}>
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={400} isVisible={true}>
													<div className="package_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.packageDetails}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.packageDetails}>Web Development</Link>
																</h4>
																<div className="secondary_btn">
																	<Link to={routes.packageDetails}>View Packages <i className="far fa-angle-right ml-2"></i></Link>
																</div>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</Col>
											<Col xl={3} lg={3} md={4} sm={6} xs={12}>
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={600} isVisible={true}>
													<div className="package_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.packageDetails}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.packageDetails}>Web Designing</Link>
																</h4>
																<div className="secondary_btn">
																	<Link to={routes.packageDetails}>View Packages <i className="far fa-angle-right ml-2"></i></Link>
																</div>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</Col>
											<Col xl={3} lg={3} md={4} sm={6} xs={12}>
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={800} isVisible={true}>
													<div className="package_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.packageDetails}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.packageDetails}>Graphic Designing</Link>
																</h4>
																<div className="secondary_btn">
																	<Link to={routes.packageDetails}>View Packages <i className="far fa-angle-right ml-2"></i></Link>
																</div>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</Col>
											<Col xl={3} lg={3} md={4} sm={6} xs={12}>
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={1000} isVisible={true}>
													<div className="package_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.packageDetails}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.packageDetails}>Digital Marketing</Link>
																</h4>
																<div className="secondary_btn">
																	<Link to={routes.packageDetails}>View Packages <i className="far fa-angle-right ml-2"></i></Link>
																</div>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</Col>
											<Col xl={3} lg={3} md={4} sm={6} xs={12}>
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={1200} isVisible={true}>
													<div className="package_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.packageDetails}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.packageDetails}>Mobile App Development</Link>
																</h4>
																<div className="secondary_btn">
																	<Link to={routes.packageDetails}>View Packages <i className="far fa-angle-right ml-2"></i></Link>
																</div>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</Col>
											<Col xl={3} lg={3} md={4} sm={6} xs={12}>
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={1400} isVisible={true}>
													<div className="package_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.packageDetails}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.packageDetails}>Google Adwords</Link>
																</h4>
																<div className="secondary_btn">
																	<Link to={routes.packageDetails}>View Packages <i className="far fa-angle-right ml-2"></i></Link>
																</div>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</Col>
											<Col xl={3} lg={3} md={4} sm={6} xs={12}>
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={1600} isVisible={true}>
													<div className="package_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.packageDetails}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.packageDetails}>CRM Development</Link>
																</h4>
																<div className="secondary_btn">
																	<Link to={routes.packageDetails}>View Packages <i className="far fa-angle-right ml-2"></i></Link>
																</div>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</Col>
											<Col xl={3} lg={3} md={4} sm={6} xs={12}>
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={1800} isVisible={true}>
													<div className="package_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.packageDetails}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.packageDetails}>E-commerce Websites</Link>
																</h4>
																<div className="secondary_btn">
																	<Link to={routes.packageDetails}>View Packages <i className="far fa-angle-right ml-2"></i></Link>
																</div>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</Col>
										</Row>
									</EqualHeight>
								</div>
							</Col>
						</Row>
					</Container>
				</div>
			</div>
		</>
	);
}

export default Packages;
